<script>
export default {
	props: {
		id: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false
		},
		settings: {
			type: Object,
			default: () => ({})
		}
	},
	methods: {
		open() {
			return new Promise((resolve) => {
				$(this.$el).modal(this.settings);
				$(this.$el).modal('show');
				$(this.$el).one('shown.bs.modal', () => {
					resolve();
				});
			});
		},

		close() {
			return new Promise((resolve) => {
				$(this.$el).modal('hide');
				$(this.$el).one('hidden.bs.modal', () => {
					resolve();
				});
			});
		}
	}
}
</script>

<template>
	<div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
		<div :class="['modal-dialog modal-dialog-centered', size ? 'modal-' + size : '']">
			<div class="modal-content">
				<div class="modal-header bg-primary text-white">
					<h2 v-if="title" class="modal-title h5 text-white" :id="id + 'Label'">{{ title }}</h2>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>

				<div class="modal-body">
					<slot></slot>
				</div>

				<div class="modal-footer" v-if="$slots.footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>